//@ts-nocheck
import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import styled from "styled-components";
import * as d3 from 'd3';
import d3tip from 'd3-tip'
import { schemeCategory10 } from 'd3-scale-chromatic';
import {
    blue,
    exportECRChart,
    filterECRHeading_AndComparison,
    compareMeasure,
    combineDataSets,
    stackedData,
    deleteECRReportImage
} from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';


const getComparisonString = (value) => {
    if (value == "F" || value == "M")
        return value;
    else if (value == 0)
        return "no";
    else if (value == 1)
        return "yes";

    return "";
}



const TeamCompositionChart = ({
    teamData,
    teamData_2,
    parentWidth,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    university,
    start_year,
    end_year,
    vintage
}) => {
    useEffect(() => {
        d3.select("#TeamCompositionChart svg").remove();
        d3.select("#TeamCompositionChart .ecr_tooltip").remove();
        deleteECRReportImage("team-chart.png", currentDateTime, report_display_id, vintage);
        
        //is compare on
        const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
        if ((compare_measure == 0 && teamData && teamData.length > 0) ||
            (compare_measure > 0 && teamData && teamData_2 && teamData.length > 0 && teamData_2.length > 0)) {

            var margin = { top: 50, right: 175, bottom: 80, left: 120 },
                width = (parentWidth || 800) - margin.left - margin.right,
                height = 420 - margin.top - margin.bottom;

            // append the svg object to the body of the page
            var svg = d3.select("#TeamCompositionChart")
                .append("svg")
                .attr("width", width + margin.left + margin.right)
                .attr("height", height + margin.top + margin.bottom)
                .append("g")
                .attr("transform",
                    "translate(" + margin.left + "," + margin.top + ")");

            var tooltipGDC = d3.select("#TeamCompositionChart").append("div")
                .attr("class", "ecr_tooltip")
                .style("opacity", 0);

            // Show the bars
            if (compare_measure == 0) {
                const maxCount = Math.max(...teamData.map(d => +d.max_95));
                // Add X axis
                var x = d3.scaleBand()
                    .range([0, width])
                    .padding([0.2]);
                x.domain(teamData.map(function (d) { return d.t_emp; }));

                svg.append("g")
                    .attr("transform", "translate(0," + height + ")")
                    .classed('tick_style', true)
                    .call(d3.axisBottom(x).tickSize(0).tickPadding(10));

                // Add Y axis
                var y = d3.scaleLinear()
                    .domain([0, maxCount])
                    .range([height, 0]);

                svg.append("g")
                    .classed('tick_style', true)
                    //.call(d3.axisLeft(y));
                    .call(d3.axisLeft(y).tickSizeOuter(0).tickFormat(d3.format("~")));


                const moveLeft = margin.left / 2 - 22;

                const laptopScreenSize = 1060
                moveLeft = (parentWidth > laptopScreenSize ? moveLeft + 8 : moveLeft - 8)

                svg.selectAll("vertLines")
                    .data(teamData)
                    .enter()
                    .append("line")
                    .attr("x1", function (d) { return (x(d.t_emp) + moveLeft) })
                    .attr("x2", function (d) { return (x(d.t_emp) + moveLeft) })
                    .attr("y1", function (d) { return (y(d.min_5)) })
                    .attr("y2", function (d) { return (y(d.max_95)) })
                    .attr("stroke", "black")
                // .style("width", 40)


                // rectangle for the main box
                svg.selectAll("boxes")
                    .data(teamData)
                    .enter().append("rect")
                    .attr("x", d => (x(d.t_emp) - x.bandwidth() / 2) + moveLeft)
                    .attr("y", d => {
                        return (d != undefined) ? y(d.q3) : y(0)
                    })
                    .attr("height", d => (d != undefined) ? (y(d.q1) - y(d.q3)) : 0)
                    .attr("width", x.bandwidth())
                    .attr("stroke", "black")
                    .style("fill", blue)
                    .on("mouseover", function (d) {
                        const dataValue = d.target.__data__;
                        let tooltipHtml = `<b>Year:</b> ${dataValue.t_emp}<br/><b>95%ile:</b> ${d3.format("~")(dataValue["max_95"])}<br/><b>Q3:</b> ${d3.format("~")(dataValue["q3"])}<br/><b>Median:</b> ${d3.format("~")(dataValue["median"])}<br/><b>Q1:</b> ${d3.format("~")(dataValue["q1"])}<br/><b>5%ile:</b> ${d3.format("~")(dataValue["min_5"])}`;

                        tooltipGDC.style("opacity", .9);

                        tooltipGDC.html(tooltipHtml)
                            .style("left", (d.layerX) + "px")
                            .style("top", (d.layerY) + "px");

                    })
                    .on("mouseout", function (d) {
                        tooltipGDC.transition()
                            .duration(500)
                            .style("opacity", 0);
                    })

                // Show the median
                svg.selectAll("medianLines")
                    .data(teamData)
                    .enter().append("line")
                    .attr("x1", d => (x(d.t_emp) - x.bandwidth() / 2) + moveLeft)
                    .attr("x2", d => (x(d.t_emp) + x.bandwidth() / 2) + moveLeft)
                    .attr("y1", d => (d != undefined) ? y(d.median) : y(0))
                    .attr("y2", d => (d != undefined) ? y(d.median) : y(0))
                    .attr("stroke", "black")
                    .style("width", x.bandwidth())


                //Add Axis Labels
                svg.append("text")
                    .attr("text-anchor", "end")
                    .attr("x", width / 2)
                    .attr("y", height + margin.top)
                    .attr("stroke", "#1d2951")
                    .attr("stroke-width", "0.1")
                    .classed('axis_style', true)
                    .text("Data Year");

                svg.append("text")
                    .attr("text-anchor", "end")
                    .attr("transform", "rotate(-90)")
                    .attr("y", -margin.left + 30)
                    .attr("x", -margin.top - 90)
                    .attr("stroke", "#1d2951")
                    .attr("stroke-width", "0.1")
                    .classed('axis_style', true)
                    .text("Team Size")
            }
            else {
                if (teamData_2 && teamData_2.length > 0) {
                    const data = combineDataSets(teamData, teamData_2, compare_measure)
                    const maxCount = Math.max(...data.map(d => +d.max_95));

                    var x0 = d3.scaleBand()
                        .rangeRound([0, width])
                        .paddingInner(0.1);

                    var x1 = d3.scaleBand()
                        .padding(0.05);

                    const years = teamData.map(function (d) { return d.t_emp; });
                    x0.domain(years);
                    x1.domain(data.map(function (d) { return d.compareValue; }))
                        .rangeRound([0, x0.bandwidth()])
                        .padding(0.2);


                    svg.append("g")
                        .attr("transform", "translate(0," + height + ")")
                        .classed('tick_style', true)
                        .call(d3.axisBottom(x0).tickSize(0).tickPadding(10));

                    // Add Y axis
                    var y = d3.scaleLinear()
                        .domain([0, maxCount])
                        .range([height, 0]);

                    svg.append("g")
                        .classed('tick_style', true)
                        //.call(d3.axisLeft(y));
                        .call(d3.axisLeft(y).tickSizeOuter(0));

                    const moveLeft = margin.left / 2 - 38;

                    let compare_groups = [];
                    if (compare_measure == 1) {
                        compare_groups = [1, 0]
                    }
                    else if (compare_measure == 2) {
                        compare_groups = ['F', 'M']
                    }

                    // Show the bars
                    svg.selectAll("vertLines")
                        // Enter in data = loop group per group
                        .data(years)
                        .enter()
                        .append("g")
                        .attr("transform", d => "translate(" + x0(d) + ",0)")
                        .selectAll("rect")
                        .data(function (d) {
                            return compare_groups.map(function (key) {
                                return { key: key, value: data.find(i => i.t_emp == d && i.compareValue == key) };
                            });
                        })
                        .enter().append("line")
                        .attr("x1", d => { return x1(d.key) + moveLeft })
                        .attr("x2", d => x1(d.key) + moveLeft)
                        .attr("y1", d => (d.value != undefined) ? y(d.value.min_5) : y(0))
                        .attr("y2", d => (d.value != undefined) ? y(d.value.max_95) : y(0))
                        //.attr("stroke", d => color(d.key))
                        .attr("stroke", "black")
                    //.style("width", x1.bandwidth())

                    // rectangle for the main box
                    svg.selectAll("boxes")
                        // Enter in data = loop group per group
                        .data(years)
                        .enter()
                        .append("g")
                        .attr("transform", d => "translate(" + x0(d) + ",0)")
                        .selectAll("rect")
                        .data(function (d) {
                            return compare_groups.map(function (key) {
                                return { key: key, value: data.find(i => i.t_emp == d && i.compareValue == key) };
                            });
                        })
                        .enter().append("rect")
                        .attr("x", d => (x1(d.key) - x1.bandwidth() / 2) + moveLeft)
                        .attr("y", d => {
                            return (d.value != undefined) ? y(d.value.q3) : y(0)
                        })
                        .attr("height", d => (d.value != undefined) ? (y(d.value.q1) - y(d.value.q3)) : 0)
                        .attr("width", x1.bandwidth())
                        .attr("stroke", "black")
                        .style("fill", blue)
                        .on("mouseover", function (d) {
                            const dataValue = d.target.__data__.value;
                            let tooltipHtml = `<b>Year:</b> ${dataValue.t_emp}<br/><b>95%ile:</b> ${d3.format("~")(dataValue["max_95"])}<br/><b>Q3:</b> ${d3.format("~")(dataValue["q3"])}<br/><b>Median:</b> ${d3.format("~")(dataValue["median"])}<br/><b>Q1:</b> ${d3.format("~")(dataValue["q1"])}<br/><b>5%ile:</b> ${d3.format("~")(dataValue["min_5"])}`;

                            tooltipGDC.style("opacity", .9);

                            //tooltipGDC.transition()
                            //    .duration(200)
                            //    .style("opacity", .9);
                            tooltipGDC.html(tooltipHtml)
                                .style("left", (d.layerX) + "px")
                                .style("top", (d.layerY) + "px");


                        })
                        .on("mouseout", function (d) {
                            tooltipGDC.transition()
                                .duration(500)
                                .style("opacity", 0);
                        })



                    // Show the median
                    svg.selectAll("medianLines")
                        // Enter in data = loop group per group
                        .data(years)
                        .enter()
                        .append("g")
                        .attr("transform", d => "translate(" + x0(d) + ",0)")
                        .selectAll("rect")
                        .data(function (d) {
                            return compare_groups.map(function (key) {
                                return { key: key, value: data.find(i => i.t_emp == d && i.compareValue == key) };
                            });
                        })
                        .enter().append("line")
                        .attr("x1", d => (x1(d.key) - x1.bandwidth() / 2) + moveLeft)
                        .attr("x2", d => (x1(d.key) + x1.bandwidth() / 2) + moveLeft)
                        .attr("y1", d => (d.value != undefined) ? y(d.value.median) : y(0))
                        .attr("y2", d => (d.value != undefined) ? y(d.value.median) : y(0))
                        .attr("stroke", "black")


                    //eca
                    if (compare_measure == 1) {
                        svg.selectAll("topLabel")
                            // Enter in data = loop group per group
                            .data(years)
                            .enter()
                            .append("g")
                            .attr("transform", d => "translate(" + x0(d) + ",0)")
                            .selectAll("rect")
                            .data(function (d) {
                                return compare_groups.map(function (key) {
                                    return { key: key, value: data.find(i => i.t_emp == d && i.compareValue == key) };
                                });
                            })
                            .enter().append("text")
                            .attr("x", d => (x1(d.key) - x1.bandwidth() / 2) + 40)
                            .attr("y", -30)
                            .text("ECA")
                            .attr("text-anchor", "middle")

                    }

                    // Show the label on top
                    svg.selectAll("topLabel")
                        // Enter in data = loop group per group
                        .data(years)
                        .enter()
                        .append("g")
                        .attr("transform", d => "translate(" + x0(d) + ",0)")
                        .selectAll("rect")
                        .data(function (d) {
                            return compare_groups.map(function (key) {
                                return { key: key, value: data.find(i => i.t_emp == d && i.compareValue == key) };
                            });
                        })
                        .enter().append("text")
                        .attr("x", d => (x1(d.key) - x1.bandwidth() / 2) + 40)
                        .attr("y", -14)
                        .text(d => getComparisonString(d.value.compareValue))
                        .attr("text-anchor", "middle")

                    //.attr("stroke", "black")

                    //.style("width", 80)


                    //Add Axis Labels
                    svg.append("text")
                        .attr("text-anchor", "end")
                        .attr("x", width / 2)
                        .attr("y", height + margin.top)
                        .attr("stroke", "#1d2951")
                        .attr("stroke-width", "0.1")
                        .classed('axis_style', true)
                        .text("Data Year");

                    svg.append("text")
                        .attr("text-anchor", "end")
                        .attr("transform", "rotate(-90)")
                        .attr("y", -margin.left + 30)
                        .attr("x", -margin.top - 90)
                        .attr("stroke", "#1d2951")
                        .attr("stroke-width", "0.1")
                        .classed('axis_style', true)
                        .text("Team Size")

                }


            }
            
            exportECRChart("#TeamCompositionChart", "team-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
        }
    }, [teamData, teamData_2, parentWidth])

    const subHeading = filterECRHeading_AndComparison(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);
    const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
    return (
        <div className="ChartComponent">
            <div id="TeamCompositionChart_ForExport">
                <Heading3 bold italic>Research Team Size for {university} Faculty</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                {((compare_measure ==0 && teamData?.length >= 0) || (compare_measure > 0 && (teamData?.length > 0 && teamData_2?.length > 0))) && <div id="TeamCompositionChart"></div>}
                {(teamData?.length == 0 || (compare_measure > 0 && (teamData?.length == 0 || teamData_2?.length == 0))) && <p className="no_data_text">Due to the small number of results and the potential for disclosure of personal information, this chart cannot be displayed. Please select a larger group.</p>}
                <ReportText>
                    This chart shows the size (median, 5th, 25th, 75th, and 95th  percentiles) of the research teams of projects on which faculty are principal investigators. “Data Year” refers to the number of years a cohort of faculty members has appeared in the IRIS-UMETRICS dataset of researchers paid on sponsored grants. Data from {start_year} to {end_year} were used to build these cohorts.
                </ReportText>
            </div>
            <a className="export" onClick={() => exportECRChart("#TeamCompositionChart_ForExport", "team-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default TeamCompositionChart;